import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { LocaleId } from '@core/config';

export interface LanguageChangeEvent {
  previousLanguage: LocaleId;
  newLanguage: LocaleId;
  timestamp: Date;
}

@Injectable({
  providedIn: 'root',
})
export class LanguageChangeService {
  private languageChangeSubject = new Subject<LanguageChangeEvent>();

  public languageChange$: Observable<LanguageChangeEvent> = this.languageChangeSubject.asObservable();

  /**
   * Notify all subscribers that the language has changed
   * This should be called whenever the language is switched to trigger backend data refresh
   */
  public notifyLanguageChange(previousLanguage: LocaleId, newLanguage: LocaleId): void {
    const event: LanguageChangeEvent = {
      previousLanguage,
      newLanguage,
      timestamp: new Date(),
    };

    this.languageChangeSubject.next(event);
  }
}
